import React from "react";
import { AiFillStar } from "react-icons/ai";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import "./style.css";
import { Pagination } from "swiper";
import img1 from "../../images/testemonile/clientSayMain.668e4587f020b4c73348.png";
import img2 from "../../images/testemonile/download (1).png";
import img3 from "../../images/testemonile/download (2).png";
import img4 from "../../images/testemonile/download (3).png";
import img5 from "../../images/testemonile/download (4).png";
import img6 from "../../images/testemonile/download (5).png";
import img7 from "../../images/testemonile/download.png";
import leftcote from "../../images/testemonile/download (6).png";
import rightcote from "../../images/testemonile/download3.png";
import "./testemonile.scss";
const Testemonile = () => {
  return (
    <>
      <div className="testemonile">
        <div className="container">
          <h1>Good news from far away 🥇</h1>
          <p>Let's see what people think of Marketo</p>
          <img src={img1} alt="testemonileimg"></img>
          <div className="floatedimg">
            <img src={img2} alt="floatimg"></img>
            <img src={img3} alt="floatimg"></img>
            <img src={img4} alt="floatimg"></img>
            <img src={img5} alt="floatimg"></img>
            <img src={img6} alt="floatimg"></img>
            <img src={img7} alt="floatimg"></img>
          </div>
          <div className="testemonile_content">
            <img src={rightcote} alt="rightcote"></img>
            <img src={leftcote} alt="leftcote"></img>
            <Swiper
              loop={true}
              pagination={true}
              modules={[Pagination]}
              className="mySwiper"
            >
              <SwiperSlide>
                <div className="testemonile_block">
                  <p>
                    Great quality products, affordable prices, fast and friendly
                    delivery. I very recommend.
                  </p>
                  <h4>Berta Emili</h4>
                  <ul>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                  </ul>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="testemonile_block">
                  <p>
                    Great quality products, affordable prices, fast and friendly
                    delivery. I very recommend.
                  </p>
                  <h4>Tiana Abie</h4>
                  <ul>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                  </ul>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="testemonile_block">
                  <p>
                    Great quality products, affordable prices, fast and friendly
                    delivery. I very recommend.
                  </p>
                  <h4>Lennie Swiffan</h4>
                  <ul>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                    <li>
                      <AiFillStar />
                    </li>
                  </ul>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
};

export default Testemonile;
